/**
 * Optimized Parallax Effect
 * Uses requestAnimationFrame for better performance
 * Disabled on mobile for performance optimization
 */
class OptimizedParallax {
  constructor() {
    this.scrollY = 0;
    this.ticking = false;
    this.elements = [];
    this.isMobile = this.checkMobile();

    // Bind methods
    this.handleScroll = this.handleScroll.bind(this);
    this.update = this.update.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  /**
   * Détecte si l'utilisateur est sur mobile
   * Désactive le parallax en dessous de 768px pour optimiser les performances
   */
  checkMobile() {
    return window.innerWidth <= 768;
  }

  init() {
    // Ne pas initialiser le parallax sur mobile
    if (this.isMobile) {
      console.log('Parallax désactivé sur mobile pour optimiser les performances');
      return;
    }

    // Find all parallax elements
    this.elements = [
      ...document.querySelectorAll('[data-parallax-bg]'),
      ...document.querySelectorAll('[data-parallax-transform]')
    ].map(el => ({
      element: el,
      speed: parseFloat(el.dataset.parallaxSpeed || 0.5),
      type: el.dataset.parallaxBg ? 'background' : 'transform'
    }));

    if (this.elements.length > 0) {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      // Initial update
      this.update();
    }
  }

  /**
   * Gère le redimensionnement de la fenêtre
   * Désactive/réactive le parallax selon la largeur
   */
  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = this.checkMobile();

    // Si on passe de desktop à mobile, nettoyer les effets
    if (!wasMobile && this.isMobile) {
      this.destroy();
      this.resetElements();
    }
    // Si on passe de mobile à desktop, réinitialiser
    else if (wasMobile && !this.isMobile) {
      this.init();
    }
  }

  /**
   * Réinitialise les transformations sur les éléments
   */
  resetElements() {
    this.elements.forEach(({ element, type }) => {
      if (type === 'background') {
        element.style.backgroundPosition = '';
      } else {
        element.style.transform = '';
        element.style.willChange = '';
      }
    });
  }

  handleScroll() {
    this.scrollY = window.pageYOffset;

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  update() {
    this.elements.forEach(({ element, speed, type }) => {
      const value = this.scrollY * speed;

      if (type === 'background') {
        element.style.backgroundPosition = `center ${value}px`;
      } else {
        element.style.transform = `translateY(${value}px)`;
        element.style.willChange = 'transform';
      }
    });
  }

  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}

// Initialize optimized parallax
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new OptimizedParallax();
  });
} else {
  new OptimizedParallax();
}
